import { Controller } from "remult";

@Controller("time-report-methods")
export class TimeReportMethods {}
